import React, { useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { convertCultureToRef } from '@/utils/common-util';
import { CdnImg } from '@/features/cdn-img';
import { usePredictionMarket } from '@/hooks/use-prediction-market';
import { NewWindowIcon } from '@/components/icons/svg-icons/svg-icons';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';

const FALLBACK_LANG = 'en';
const getImagePath = (lang: string) => `/images/promotion-activity-modal/prediction-market-slider/${lang}.png`;

interface PredictionMarketSliderProps {
	onClose: () => void;
}

export const PredictionMarketSlider: React.FC<PredictionMarketSliderProps> = ({
	onClose,
}) => {
	const locale = useLocale();
	const t = useTranslations('General');
	const { openPredictionMarket } = usePredictionMarket();
	const shortLang = convertCultureToRef(locale ?? 'en-US');
	const lang = shortLang === 'zhcn' ? 'cs' : shortLang;
	const [imageSrc, setImageSrc] = useState(getImagePath(lang));

	const handleClickButton = async () => {
		setKafkaNormal({ note: KafkaNote.PredictionMarket, type: 1, action: 1 });
		openPredictionMarket();
		onClose();
	};

	const handleImageError = () => {
		setImageSrc(getImagePath(FALLBACK_LANG));
	};

	return (
		<div className="prediction-market-slider">
			<CdnImg
				src={imageSrc}
				alt=""
				width={288}
				height={360}
				isGalaxyFolder={true}
				onError={handleImageError}
			/>
			<button
				className="prediction-market-slider__btn"
				onClick={handleClickButton}
			>
				{t('lbl_PredictMarketPopup03')}
				<NewWindowIcon className="prediction-market-slider__btn-icon" />
			</button>
		</div>
	);
};
